import { useLocation } from "react-router-dom";
import { Head } from "./head";

const SECTION_TITLES: Record<string, string> = {
  dashboard: "Dashboard",
  projects: "Projects",
  tasks: "Tasks",
  invoices: "Invoices",
  contractors: "Contractors",
  documents: "Documents",
  "daily-logs": "Daily Logs",
  users: "Users",
  "purchase-orders": "Purchase Orders",
  suppliers: "Suppliers",
  clients: "Clients",
  materials: "Material Decisions",
  "change-orders": "Change Orders",
  milestones: "Milestones",
  punchlists: "Punch List",
  photos: "Photos",
  notifications: "Notifications",
  "audit-logs": "Audit Logs",
  portal: "Client Portal",
};

const SUBSECTION_TITLES: Record<string, Record<string, string>> = {
  reports: {
    "": "Reports",
    financial: "Financial Report",
    projects: "Projects Report",
    "time-tracking": "Time Tracking Report",
  },
  settings: {
    "": "Settings",
    profile: "Profile",
    preferences: "Preferences",
    company: "Company",
    notifications: "Notification Settings",
  },
};

export const PageTitle = () => {
  const { pathname } = useLocation();
  const parts = pathname.split("/").filter(Boolean);

  if (parts.length === 0) {
    return <Head title="Dashboard" />;
  }

  const [first, second] = parts;

  // The project detail page sets its own title (project name + tab).
  if (first === "projects" && parts.length >= 2) {
    return null;
  }

  let title: string | null = null;
  if (SUBSECTION_TITLES[first]) {
    title = SUBSECTION_TITLES[first][second ?? ""] ?? SECTION_TITLES[first] ?? null;
  } else {
    title = SECTION_TITLES[first] ?? null;
  }

  if (!title) return null;
  return <Head title={title} />;
};

export default PageTitle;
